













































































import { Vue, Component, Prop } from 'vue-property-decorator';
import {
  TransactionHttp, TransactionGroup, Account,
  CosignatureTransaction, AggregateTransaction, Address,
} from 'symbol-sdk';
import {
  AuditService, IAuditResult, IPartialTxAuditResult,
} from 'simple-apostille-v2';
import * as fileReader from 'promise-file-reader';
import ConfirmedResult from '@/components/audit/ConfirmedResultComponent.vue';
import PartialResult from '@/components/audit/PartialResultComponent.vue';
import ApostilleService from '@/libs/ApostilleService';
import AppConfig from '@/libs/AppConfig';
import AMetadata from '@/models/AMetadata';
import FileDropArea from '../components/createapostille/FileDropArea.vue';
import Snackbar from '../util/snackbar';

@Component({
  components: {
    ConfirmedResult,
    PartialResult,
    FileDropArea,
  },
})
export default class AuditPage extends Vue {
  @Prop()
  public showSnackbar!: (text: string) => void

  private isValid = false;

  private isLoading = false;

  private file: File | null = null;

  private txHash = '';

  private fileRules = [
    (v: File) => !!v || 'ファイルを設定してください',
  ];

  private filename = '';

  private confrimedVaild = false;

  private partialValid = false;

  private showAlert = false;

  private alertType = '';

  private alertText = '';

  private auditResult: IAuditResult | IPartialTxAuditResult | null = null;

  private cosignatories: Address[] = [];

  private metadatas: AMetadata[] = [];

  private networkType = AppConfig.networkType();

  private async onClickAudit() {
    this.resetResult();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const refs: any = this.$refs;
    if (refs.form.validate() && this.file) {
      this.getTxHash(this.file.name);
      if (this.txHash) {
        await this.audit();
      } else {
        this.showAlertNotApostilleFile();
      }
    }
  }

  private getTxHash(filename: string) {
    const regexp = /--\sApostille\sTX\s(\w+)\s--/;
    const match = filename.match(regexp);
    if (match) {
      this.txHash = match[1] as string;
    }
  }

  private async audit() {
    if (this.file && this.txHash) {
      this.filename = this.file.name;
      const fileBuffer = await fileReader.readAsArrayBuffer(this.file);
      AuditService.audit(
        fileBuffer,
        this.txHash,
        AppConfig.apiEndpoint(),
      ).then((r) => {
        if (this.isPartialVaild(r)) {
          this.showSuccesssPatialResult(r);
        } else if (this.isConfirmedValid(r)) {
          this.showSuccessConfirmedResult(r);
        } else {
          this.showAlertFailedAudit();
        }
      }).catch((err) => {
        console.error(err);
        this.showAlertFailedAudit();
      });
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private isConfirmedValid(r: any) {
    return r.isValid && r.type === 0;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private isPartialVaild(r: any) {
    return r.isValid && r.type === 1;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private showSuccessConfirmedResult(r: any) {
    this.confrimedVaild = true;
    this.auditResult = r;
    this.getMultisigAccountInfo();
    this.getMetadata();
    this.showSuccessAlert();
  }

  private async getMultisigAccountInfo() {
    if (this.auditResult && this.auditResult.apostilleAccount) {
      this.cosignatories = await ApostilleService
        .getMultisigAccountCosigner(this.auditResult.apostilleAccount);
    }
  }

  private async getMetadata() {
    if (this.auditResult && this.auditResult.apostilleAccount) {
      this.metadatas = await ApostilleService.getMetadata(this.auditResult.apostilleAccount);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private async showSuccesssPatialResult(r: any) {
    this.partialValid = true;
    this.auditResult = r;
    this.metadatas = await ApostilleService.getMetadataFromHash(this.txHash);
    this.showPartialAlert();
  }

  private showSuccessAlert() {
    this.showAlert = true;
    this.alertType = 'success';
    this.alertText = '監査に成功しました';
  }

  private showPartialAlert() {
    this.showAlert = true;
    this.alertType = 'info';
    this.alertText = 'このファイルは他のアカウントの承認を待っています';
  }

  private showAlertNotApostilleFile() {
    this.showAlert = true;
    this.alertType = 'error';
    this.alertText = 'このファイルはアポスティーユフォーマットではありません';
  }

  private showAlertFailedAudit() {
    this.showAlert = true;
    this.alertType = 'warning';
    this.alertText = '監査に失敗しました.';
  }

  private onClickRest() {
    this.file = null;
    this.resetResult();
  }

  private resetResult() {
    this.confrimedVaild = false;
    this.partialValid = false;
    this.auditResult = null;
    this.showAlert = false;
    this.alertType = '';
    this.alertText = '';
  }

  private async cosign(cosignatoryKey: string) {
    try {
      const account = Account.createFromPrivateKey(cosignatoryKey, this.networkType);
      const transactionHttp = new TransactionHttp(AppConfig.apiEndpoint());
      const txs = await transactionHttp
        .getTransactionsById([this.txHash], TransactionGroup.Partial).toPromise();
      if (txs.length) {
        const tx = txs[0] as AggregateTransaction;
        const cosignatureTransaction = CosignatureTransaction.create(tx);
        const signedTx = account.signCosignatureTransaction(cosignatureTransaction);
        transactionHttp.announceAggregateBondedCosignature(signedTx).subscribe((x) => {
          this.showSnackbar(Snackbar.SUCCESS_COSIGN);
        }, (err) => {
          throw (err);
        });
      }
    } catch (err) {
      console.error(err);
      this.showSnackbar(Snackbar.FAILED_COSIGN);
    }
  }

  private failedReadQRKeyFromComponent() {
    this.showSnackbar(Snackbar.FAILED_READ_QRKEY);
  }

  private isDragOver = false;

  private onDrag(type: string) {
    this.isDragOver = type === 'over';
  }

  private onChange(event: any) {
    const { files } = event.target;
    this.file = files[0] as File;
  }

  private onClickRemoveFile() {
    this.file = null;
  }
}
